export default __webpack_public_path__ + "static/media/celtics-city.2b790295.jpeg";